import { useTheme } from "@mui/material";
import { useState, useRef, useLayoutEffect } from "react";
import isEqual from "../external/lodash-es/isEqual.js";
const nextBp = {
  xs: "sm",
  sm: "md",
  md: "lg",
  lg: "xl",
  xl: "xxl",
  xxl: "xxl"
}, calcState = (width, calcFor, breakpoints) => {
  const d = {};
  for (const b of calcFor) {
    const bpValue = breakpoints[b], nextBpValue = breakpoints[nextBp[b]];
    d[b] = width >= bpValue, d[`${b}Only`] = width >= bpValue && (b === "xxl" || width < nextBpValue);
  }
  return d;
}, useBoxBreakpoints = (id, breakpoints) => {
  const [one, two, three, four, five, six] = breakpoints, theme = useTheme(), [state, setState] = useState({}), ref = useRef({ bpValues: theme.breakpoints.values, state });
  return ref.current = {
    bpValues: theme.breakpoints.values,
    state
  }, useLayoutEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    let tmtId;
    const calcFor = [one, two, three, four, five, six].filter(Boolean), newObserver = new ResizeObserver(([observerEntry]) => {
      const width2 = observerEntry.contentRect.width, handleSizeChanged = () => {
        const calculated2 = calcState(width2, calcFor, ref.current.bpValues);
        isEqual(ref.current.state, calculated2) || setState(calculated2);
      };
      clearTimeout(tmtId), tmtId = setTimeout(handleSizeChanged, 0);
    }), { width } = el.getBoundingClientRect(), calculated = calcState(width, calcFor, ref.current.bpValues);
    return isEqual(ref.current.state, calculated) || setState(calculated), newObserver.observe(el, { box: "border-box" }), () => {
      newObserver.unobserve(el), newObserver.disconnect();
    };
  }, [five, four, id, one, six, three, two]), state;
};
export {
  useBoxBreakpoints
};
//# sourceMappingURL=useBoxBreakpoints.js.map
